import React, { useEffect, useRef, useMemo, useCallback, useState, use } from 'react';
import './App.scss';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import scenesData from './data/sceneimages.json';

import useIsMobile from './useIsMobile';

gsap.registerPlugin(ScrollTrigger);

function Intro() {
    const path = process.env.PUBLIC_URL;
    // const gridItemsRef = useRef([]);
    // const containerRef = useRef(null);
    
    // const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setIsMobile(window.innerWidth <= 768);
    //     };
    //     window.addEventListener("resize", handleResize);
    //     return () => window.removeEventListener("resize", handleResize);
    // }, []);

    const isMobile = useIsMobile();

    const gridItems = useMemo(() => {
        return scenesData.map((image, i) => {
            const randomOffset = Math.random() * 50 - 15;
            return {
                ...image,
                randomOffset,
                index: i
            };
        });
    }, []);

    // Use useCallback to memoize the animation function
    const setupScrollAnimations = useCallback(() => {
        const items = document.querySelectorAll('.grid__item');
        
        // Cleanup existing animations if any
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());

        // Create a timeline for sequential animation
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.grid',
                start: "top+=220 center-=120",
                end: "bottom center+=100",
                scrub: 1,
                // markers: true
            }
        });

        items.forEach((item, index) => {
            const img = item.querySelector('img');
            const info = item.querySelector('.grid__info');

            // Initial setup
            gsap.set(info, { 
                opacity: 0,
                y: 20
            });
            gsap.set(img, { 
                filter: 'grayscale(100%)',
                outline: '1px solid #151515',
                boxShadow: '0',
            });

            // Animation sequence
            tl.to(img, {
                filter: 'grayscale(0%)',
                outline: '1px solid black',
                boxShadow: '0px 0px 15px 0px rgba(239,215,163,0.2)',
                duration: 0.4,
            })
            .to(info, {
                opacity: 1,
                y: 0,
                duration: 0.2,
            })
            .to({}, { duration: 1.5 });

            // Fade out for non-last items
            if (index < items.length - 1) {
                tl.to(info, {
                    opacity: 0,
                    yPercent: -20,
                    y: -20,
                    duration: 0.3,
                }, ">")
                .to(img, {
                    filter: 'grayscale(100%)',
                    duration: 0.3,
                    outline: '0',
                    boxShadow: '0 0 0 0 rgba(0,0,0,0)',
                }, "<");
            }
        });

        return () => {
            tl.scrollTrigger?.kill();
        };
    }, [isMobile]);

    // Use useEffect to set up animations
    useEffect(() => {
        const cleanup = setupScrollAnimations();
        return cleanup;
    }, [setupScrollAnimations]);

    
    useEffect(() => {



    //     const items = gridItemsRef.current.map(item => ({
    //       info: item.querySelector('.grid__info'),
    //       img: item.querySelector('img')
    //     }));
        

    //     // Set initial states
    //     items.forEach(({info, img}) => {
    //       gsap.set(info, { 
    //           opacity: 0,
    //           y: 20
    //       });
    //       gsap.set(img, { 
    //           filter: 'grayscale(100%)',
    //           outline:'0',
    //           boxShadow:'0',
    //       });
    //   });


    //     // Create a timeline for sequential animation
    //     const tl = gsap.timeline({
    //         scrollTrigger: {
    //             trigger: containerRef.current,
    //             start: "top+=220 center-=120",
    //             end: "bottom center+=100",
    //             scrub: 1,
    //             // markers: true,
    //         }
    //     });

    //     // Add each wrapper to the timeline with sequential timing
    //     items.forEach(({info, img, grid__item}, index) => {
    //         tl
    //           .to(img, {
    //             filter:'grayscale(0%)',
    //             outline:'1px solid black',
    //             boxShadow:'0px 0px 15px 0px rgba(239,215,163,0.2)',
    //             duration:0.4,
    //           })
    //           .to(info, {
    //             opacity: 1,
    //             y: 0,
    //             duration: 0.2,
    //         })
            
    //         // Add a small pause between each animation
    //         .to({}, { duration: 1.5 }) 
    //         // If it's not the last item, set up the fade out of the current item
    //         // when the next one appears
    //         if (index < items.length - 1) {
    //             tl
    //               .to(info, {
    //                 opacity: 0,
    //                 yPercent: -20,
    //                 y: -20,
    //                 duration: 0.3,
    //             }, ">")
    //               .to(img, {
    //                 filter:'grayscale(100%)',
    //                 duration:0.3,
    //                 outline:'0',
    //                 boxShadow:'0 0 0 0 rgba(0,0,0,0)',
    //               }, "<");
    //         }
    //     });

    //     // Cleanup function
    //     return () => {
    //         if (tl.scrollTrigger) {
    //             tl.scrollTrigger.kill();
    //         }
    //     };
    }, [setupScrollAnimations]);

    return (
        <>
            <div className="grid-container-left">
                {/* Left Side: Main Body Text */}
                <div className="intro">
                    {!isMobile && <div style={{ height:'25vh'}}></div>}
                    {!isMobile && <h1 className="intro__title fade-in">
                        “失意的中年人”<span>,</span><br/>社会怨气<span>,</span><br/><span>以及</span>“火速办案”<span>和</span>死刑
                        <span className="intro__subtitle"><br/>——2000到2024，我们从中国的无差别袭击事件看到什么？</span>
                    </h1>
                    }
                    <div style={ isMobile ? { height:"18vh" } : { height:"30vh" } }></div>
                    
                    <div className="intro__text article-body">
                            
                    <p>2024年11月11日的珠海市，夜幕中的体育馆中心全民健身广场，像往常一样热闹。父母带着孩子在散步，旁边有中老年人在跳广场舞，也有几个统一穿着的徒步团，音乐声响亮。突然，一辆“北汽”越野车飞速驶来，撞破了体育场大门，沿跑道冲进了人群。</p>

                    <p>从媒体报道中，可以大致还原当时的情景。空旷的操场上，躺着很多人，<a href="https://cn.nytimes.com/china/20241114/china-car-zhuhai-ramming/dual/" target="_blank">周围</a>是他们撞飞的鞋和包。有人试图给躺在地上的人做心脏复苏， <a href="https://www.youtube.com/watch?v=QgWHDjZbVto" target="_blank">大喊</a>着“谁会啊，帮我！” 幸存者用“<a href="https://theinitium.com/zh-hans/article/20241230-mainland-zhuhai-car-attack-aftermath" target="_blank">惨绝人寰</a>”来形容这场灾祸，它至少造成了35人死亡，43人受伤。</p>

                    <p>根据公开信息，2024年，中国共发生了17起公共场合的惨案。许多鲜活的生命毫无征兆地结束在体育场、购物广场、街道、校门口、地铁站⋯⋯幸存者的人生也因这无妄之灾而发生转折。在世界的其它角落，类似的事件也还同样在上演。这种在公共场所，由独立个体对多位陌生人发起的暴力行为，我们称之为“<a href="http://lawdata.com.tw/tw/detail.aspx?no=276018" target="_blank">无差别袭击事件</a>”。
                    </p>

                    
                    </div>
                </div>
        
                {/* Right Side: Image Grid */}
                <div className="grid">
                    {gridItems.slice(0, 4).map((image, index) => (
                        <div
                            key={image.id || image.index}
                            className='grid__item'
                            style={{
                                gridColumn: image.gridcolumn,
                                gridRow: image.gridrow,
                                transform: `translateY(${image.randomOffset}px)`
                            }}
                        >
                            <div className='grid__labelwrapper'>
                                <div className='grid__date'>{image.date}</div>
                                <img 
                                    src={`${path}/scene-images/${image.src}`} 
                                    alt={image.scene} 
                                    className='fade-in'
                                />
                                <div className='grid__info'>
                                    <div className='grid__city'>{image.city}</div>
                                    <div className='grid__label'>{image.scene}</div>
                                    <div className='grid__label'>死：<b>{image.death}</b>, 伤：<b>{image.injury}</b></div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {isMobile && <div style={{gridColumn:`span 3`, gridRow:4, zIndex:100}}>
                        <h1 className="intro__title fade-in">
                            “失意的中年人”<span>,</span><br/>社会怨气<span>,</span><br/><span>以及</span>“火速办案”<span>和</span>死刑
                            <span className="intro__subtitle"><br/>——2000到2024，我们从中国的无差别袭击事件看到什么？</span>
                        </h1>
                        </div>}

                    {gridItems.slice(4).map((image, index) => (
                        <div
                            key={image.id || image.index}
                            className='grid__item'
                            style={{
                                gridColumn: image.gridcolumn,
                                gridRow: !isMobile ? image.gridrow : image.gridrow + 1,
                                transform: `translateY(${image.randomOffset}px)`
                            }}
                        >
                            <div className='grid__labelwrapper'>
                                <div className='grid__date'>{image.date}</div>
                                <img 
                                    src={`${path}/scene-images/${image.src}`} 
                                    alt={image.scene} 
                                />
                                <div className='grid__info'>
                                    <div className='grid__city'>{image.city}</div>
                                    <div className='grid__label'>{image.scene}</div>
                                    <div className='grid__label'>死：<b>{image.death}</b>, 伤：<b>{image.injury}</b></div>
                                </div>
                            </div>
                        </div>
                    ))}


                </div>
                {/* <div className="grid" ref={containerRef}>
                    {scenesData.map((image, i) => {
                        const randomOffset = Math.random() * 50 - 15;
                        return (
                            <div
                                // key={image.id}
                                key={image.id || i}
                                className='grid__item'
                                ref={el => gridItemsRef.current[i] = el}
                                style={{
                                    gridColumn: `${image.gridcolumn}`,
                                    gridRow: `${image.gridrow}`,
                                    transform: `translateY(${randomOffset}px)`
                                }}
                            >
                                <div className='grid__labelwrapper'>
                                <div className='grid__date'>
                                    {image.date} </div>
                                <img src={path + `/scene-images/` + image.src} alt={image.scene} />
                                    <div className='grid__info'>
                                      <div className='grid__city'>{image.city}</div>
                                      <div className='grid__label'>{image.scene}</div>
                                      <div className='grid__label'>死：<b>{image.death}</b>, 伤：<b>{image.injury}</b></div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div> */}
    
            </div>

            <div className="center-container">
            <div style={ isMobile ? { height:"18vh" } : { height:"30vh" } }></div>
                <div className="article-body">
                <p>在所有犯罪类型中，有学者<a href="https://www.lawbank.com.tw/treatise/pl_article.aspx?AID=P000234952#:~:text=%E7%B6%93%E7%B5%B1%E8%A8%88%E6%AF%94%E8%BC%83%E5%BE%8C%E7%99%BC%E7%8F%BE,%E8%A8%88%E7%95%AB%E4%B9%8B%E7%A9%A9%E5%AE%9A%E6%A8%A1%E5%BC%8F%E3%80%82" target="_blank">统计</a>，无差别袭击事件仅占不足1%。数量不多，但因其袭击对象的“随机性”和犯罪规律的“突发性”与“暴力性”，却更易引发公众安全感的缺失和社会群体的恐慌。</p>

                <p>歪脑采用“滚雪球”的方法，整理了自2000年以来，媒体公开报道过的中国无差别袭击事件，我们共找到141件，这些案件造成629人死亡，1621人受伤。因中国媒体审查、时间跨度大等因素，实际数字或许比我们收集到的更多。</p>

                <p>“无差别袭击事件”是个全球现象。歪脑也对比了日本、台湾和美国的相关数据，采访社会学、法律界等学者，查阅相关研究，寻找无差别袭击事件的共性和中国问题的独特性。目前大多无差别袭击事件的信息，都集中在个案，歪脑整合20多年的个案披露信息，以期从数据中，描摹出行凶者可能所处的社会困境，试图理解这些案件的犯罪原因，寻找可能的社会根源与顽疾。</p>

                <p>每个人都有可能成为下一个“无差别袭击事件“的受害者。不再掩盖，正视它，理解它，才是解决问题的希望所在。</p>

                </div>
                <div></div>
            </div>
        </>
        
    );
}

export default Intro;